import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/about-qbd/projects/eu-grants")({
  head: () => buildRouteHead("/en/about-qbd/projects/eu-grants", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/eu-grants", replace: true });
  },
});
